import L from 'leaflet'
import { CanvasShipUtils } from '@map-sdk/sdk/utils/CanvasShipUtils'
import { AreaViewBase } from '@map-sdk/sdk/plugins/AreaView/AreaViewBase'
import { result } from '@map-sdk/sdk/plugins/AreaView/layer/EarthQuakeAreaSymbolData'
import type { AreaViewBaseOptions } from '@map-sdk/sdk/plugins/AreaView/AreaViewBase'
import type { MyMap } from '@map-sdk/sdk/ShipxyAPISDK'

class EarthQuakeAreaSymbol extends AreaViewBase {
  earthQuakeGroup: L.LayerGroup | null = null
  earthQuakeGroupClear = true
  isInit = true
  list: { [key: string]: any } = result.data

  constructor(map: MyMap, options?: Partial<AreaViewBaseOptions>) {
    super(map, { minzoom: 2, maxzoom: 18, ...options })
    this._data = this.list
  }

  _show() {
    if (!this.earthQuakeGroup)
      this.earthQuakeGroup = L.layerGroup().addTo(this._map)
    const bounds = L.latLngBounds(L.latLng(0, 0), L.latLng(0, 0))
    const defaultLatLng = [
      [46.164614, 63.586602],
      [46.163023, 117.942464],
      [23.079732, 117.949548],
      [23.079732, 63.586602],
    ]
    defaultLatLng.forEach((p) => {
      bounds.extend(L.latLng(p[0], p[1]))
    })
    this.list.forEach(
      (obj: {
        lat: number
        lon: number
        time_conv: any
        m_conv: any
        depth: any
        location: any
      }) => {
        //points_conv:"38.779167,120.070167"
        const point = [obj.lat / 1000000, obj.lon / 1000000]
        const latlon = CanvasShipUtils.GPSEncryptByMapToLatLng(
          L.latLng([point[0], point[1]]),
          this._map
        )
        if (!bounds.contains(latlon)) {
          const m = L.marker(latlon, {
            icon: L.icon({
              iconUrl: 'https://cdn.xplusship.com/img/images/earthQuake1.png',
              iconSize: [20, 28], // size of the icon
              shadowSize: [0, 0], // size of the shadow
              iconAnchor: [10, 14], // point of the icon which will correspond to marker's location
              shadowAnchor: [0, 0], // the same for the shadow
              popupAnchor: [0, 0],
            }),
          })
          let tipHtm = ''
          tipHtm += '<div class="nav_tooltip_content">'
          tipHtm += '<div class="nav_from ">信息来源：中国地震台网中心</div>'
          tipHtm += `<div class="earth_content">发震时刻：${obj.time_conv}(UTC+8)</div>`
          tipHtm += `<div class="earth_content">纬度：${CanvasShipUtils.latFormatter(
            point[0]
          )}</div>`
          tipHtm += `<div class="earth_content ">经度：${CanvasShipUtils.lngFormatter(
            point[1]
          )}</div>`
          tipHtm += `<div class="earth_content">震级(M)：${obj.m_conv}</div>`
          tipHtm += `<div class="earth_content">深度(km)：${obj.depth}</div>`
          tipHtm += `<div class="nav_time ">参考位置：${obj.location}</div></div>`
          m.bindTooltip(`<em></em>${tipHtm}`, {
            direction: 'right',
            permanent: false,
            className: 'nav_tooltip',
          })
          this.earthQuakeGroup && this.earthQuakeGroup.addLayer(m)
        }
      }
    )
    this.earthQuakeGroupClear = false
  }
  _hide() {
    if (this.earthQuakeGroup) this.earthQuakeGroup.clearLayers()
    this.earthQuakeGroupClear = true
  }
}

const earthQuakeAreaSymbol = (
  map: MyMap,
  options?: Partial<AreaViewBaseOptions>
) => new EarthQuakeAreaSymbol(map, options)

export { EarthQuakeAreaSymbol, earthQuakeAreaSymbol }
